import SessionIcon from '../../assets/icons/session.svg?react';
import { NotificationPage } from '../../components/NotificationPage/NotificationPage';
import { Message } from '../../components/Messages/Message';
import { useThemeContext } from '../../../features/Theme/providers/ThemeContextProvider';
import { useTranslationsContext } from '../../../features/Translations/providers/TranslationsContextProvider';
import { MeetDomainEvents } from '../../../features/Meet';
import { publish } from '../../../features/EventsBus/services/service';
import { useEffect } from 'react';
import { get, remove } from '../../../features/SessionStorageState/services/service';
import { REDIRECT_TO_STORAGE_KEY } from '../waiting-room/WaitingRoomFactory';

const REDIRECT_DELAY_MS = 3000;

export function FinishPage() {
	const theme = useThemeContext();
	const { t } = useTranslationsContext();

	useEffect(() => {
		publish(MeetDomainEvents.finishPage);
	}, []);

	useEffect(() => {
		const redirectTo = get<string>(REDIRECT_TO_STORAGE_KEY);
		if (!redirectTo) return;

		remove(REDIRECT_TO_STORAGE_KEY);
		const timer = setTimeout(() => {
			window.location.replace(redirectTo);
		}, REDIRECT_DELAY_MS);

		return () => clearTimeout(timer);
	}, []);

	return (
		<NotificationPage
			prepend={<SessionIcon fill={theme.colors.brand.primary[300]} width={25} height={25} />}
			title={t('vc.finish_title')}
		>
			<Message message={t('vc.finish_content')} type={'success'}></Message>
		</NotificationPage>
	);
}
